import UpdateCreditBalanceDialog from "./update-credit-balance-dialog.container";

export default UpdateCreditBalanceDialog;
